import script from "./NavbarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarMobile.vue?vue&type=script&setup=true&lang=js"

import "./NavbarMobile.vue?vue&type=style&index=0&id=663d37e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663d37e6"]])

export default __exports__